import { render, staticRenderFns } from "./Faucet.vue?vue&type=template&id=61889a33&scoped=true"
import script from "./Faucet.vue?vue&type=script&lang=js"
export * from "./Faucet.vue?vue&type=script&lang=js"
import style0 from "./Faucet.vue?vue&type=style&index=0&id=61889a33&prod&lang=scss&scoped=true"
import style1 from "./Faucet.vue?vue&type=style&index=1&id=61889a33&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61889a33",
  null
  
)

export default component.exports